"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasSlideshow = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _Colors = _interopRequireDefault(require("../../../../Assets/Colors"));

var _Fonts = require("../../../../Assets/Fonts");

var _react = _interopRequireDefault(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _reactTracking = _interopRequireDefault(require("react-tracking"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _resizer = require("../../../../Utils/resizer");

var _Helpers = require("../../../Helpers");

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _CanvasContainer = require("./CanvasContainer");

var _dec, _dec2, _class, _class2, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    max-height: ", "\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  max-width: ", "\n  object-fit: cover;\n  object-position: center;\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    max-width: calc(100% - 40px);\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 20px;\n    width: 100%;\n    a {\n      height: initial;\n      max-height: initial;\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 40px;\n    width: ", "\n    a {\n      max-height: ", "\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 380px;\n  padding: 0 20px 0 0;\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      max-width: ", "\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 20px;\n  &.title-card {\n    max-width: 1170px;\n    margin-left: 40px;\n    width: ", "\n    display: flex !important;\n    justify-content: space-between;\n\n    ", "\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    max-height: ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow: hidden;\n  .slick-list {\n    max-height: ", "\n    padding: 0 !important;\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  height: 100%;\n  max-height: ", "\n  top: 0;\n  box-sizing: border-box;\n  opacity: ", "\n  transition: opacity .5s;\n  ", "\n  ", "\n  ", " {\n    z-index: 10;\n    cursor: pointer;\n    padding: 10px;\n    background: rgba(255, 255, 255, .8);\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);\n    border-radius: 2px;\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

var CanvasSlideshow = (_dec = (0, _reactTracking.default)(), _dec2 = (0, _reactTracking.default)(function (props) {
  return {
    action: "Click",
    label: "Display ad carousel arrow",
    entity_type: "display_ad",
    campaign_name: props.campaign.name,
    unit_layout: "canvas_slideshow"
  };
}), _dec(_class = (_class2 = (_temp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CanvasSlideshow, _React$Component);

  function CanvasSlideshow(props) {
    var _this;

    _classCallCheck(this, CanvasSlideshow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CanvasSlideshow).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "slider", void 0);

    _defineProperty(_assertThisInitialized(_this), "afterSlideChange", function (currentSlide) {
      _this.setState({
        isOnTitle: currentSlide === 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSlides", function () {
      var _this$props = _this.props,
          unit = _this$props.unit,
          containerWidth = _this$props.containerWidth;
      return unit.assets.map(function (image, i) {
        var renderTitleCard = i === 0 && containerWidth >= 900;
        var imageSrc = (0, _resizer.crop)(image.url, {
          width: 780,
          height: 460,
          isDisplayAd: true
        });
        var caption = image.caption || "";
        return _react.default.createElement(Slide, {
          key: i,
          className: i === 0 && "title-card",
          containerWidth: containerWidth
        }, renderTitleCard && _this.renderTitleCard(), _react.default.createElement("div", null, _react.default.createElement(Image, {
          src: imageSrc,
          alt: caption,
          containerWidth: containerWidth
        }), caption && _react.default.createElement(Caption, null, image.caption)));
      });
    });

    _this.onChangeSlide = _this.onChangeSlide.bind(_assertThisInitialized(_this));
    _this.state = {
      isOnTitle: true
    };
    return _this;
  }

  _createClass(CanvasSlideshow, [{
    key: "onChangeSlide",
    value: function onChangeSlide(slide) {
      this.slider.slickGoTo(slide);
    }
  }, {
    key: "renderTitleCard",
    value: function renderTitleCard() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          disclaimer = _this$props2.disclaimer,
          containerWidth = _this$props2.containerWidth,
          unit = _this$props2.unit;
      var renderDisclaimer = (0, _compact2.default)((0, _map2.default)(unit.assets, "caption")).length > 0;
      return _react.default.createElement(Title, {
        containerWidth: containerWidth
      }, children, renderDisclaimer && _react.default.createElement(Disclaimer, null, disclaimer));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var containerWidth = this.props.containerWidth;
      var sliderSettings = {
        dots: false,
        infinite: false,
        variableWidth: true,
        centerMode: true,
        nextArrow: _react.default.createElement(RightArrow, {
          containerWidth: containerWidth,
          onChangeSlide: this.onChangeSlide
        }),
        prevArrow: _react.default.createElement(LeftArrow, {
          containerWidth: containerWidth,
          onChangeSlide: this.onChangeSlide,
          isOnTitle: this.state.isOnTitle
        }),
        initialSlide: 0,
        afterChange: function afterChange(currentSlide) {
          _this2.afterSlideChange(currentSlide);
        },
        responsive: [{
          breakpoint: 900,
          settings: {
            infinite: true,
            // FIXME: Follow up on whether this controls anything
            // @ts-ignore
            controls: false
          }
        }]
      };
      var renderTitleCard = containerWidth < 900;
      return _react.default.createElement("div", null, _react.default.createElement(SliderContainer, {
        containerWidth: containerWidth
      }, _react.default.createElement(_reactSlick.default, _extends({}, sliderSettings, {
        ref: function ref(slider) {
          return _this2.slider = slider;
        }
      }), this.renderSlides())), renderTitleCard && this.renderTitleCard());
    }
  }]);

  return CanvasSlideshow;
}(_react.default.Component), _temp), (_applyDecoratedDescriptor(_class2.prototype, "onChangeSlide", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeSlide"), _class2.prototype)), _class2)) || _class);
exports.CanvasSlideshow = CanvasSlideshow;

var LeftArrow = function LeftArrow(props) {
  var slide = props.currentSlide - 1 >= 0 ? 0 : props.currentSlide - 1;
  return _react.default.createElement(NavArrow, {
    containerWidth: props.containerWidth,
    direction: "left",
    onClick: function onClick() {
      return props.onChangeSlide(slide);
    },
    isVisible: !props.isOnTitle
  }, _react.default.createElement(_Icon.default, {
    name: "chevron-left",
    color: "black",
    fontSize: "24px"
  }));
};

var RightArrow = function RightArrow(props) {
  var slide = props.currentSlide + 1 === props.slideCount ? 0 : props.currentSlide + 1;
  return _react.default.createElement(NavArrow, {
    containerWidth: props.containerWidth,
    direction: "right",
    onClick: function onClick() {
      return props.onChangeSlide(slide);
    },
    isVisible: true
  }, _react.default.createElement(_Icon.default, {
    name: "chevron-right",
    color: "black",
    fontSize: "24px"
  }));
};

var arrowDiv = _styledComponents.default.div;
var responsiveDiv = _styledComponents.default.div;
var responsiveImage = _styledComponents.default.img;
var NavArrow = arrowDiv(_templateObject(), function (props) {
  return (0, _CanvasContainer.maxAssetSize)(props.containerWidth).height + "px;";
}, function (props) {
  return props.isVisible ? "1;" : "0;";
}, function (props) {
  return props.direction === "left" && "left: 0px;";
}, function (props) {
  return props.direction === "right" && "right: 0px;";
}, _Icon.default, _Helpers.pMedia.md(_templateObject2()));
var SliderContainer = responsiveDiv(_templateObject3(), function (props) {
  return "calc(" + (0, _CanvasContainer.maxAssetSize)(props.containerWidth).height + "px + 2.5em);";
}, function (props) {
  return _Helpers.pMedia.md(_templateObject4(), (0, _CanvasContainer.maxAssetSize)(props.containerWidth).height + "px;");
});
var Slide = responsiveDiv(_templateObject5(), function (props) {
  return props.containerWidth + "px;";
}, function (props) {
  return _Helpers.pMedia.md(_templateObject6(), (0, _CanvasContainer.maxAssetSize)(props.containerWidth).width + "px;");
});
var Title = responsiveDiv(_templateObject7(), function (props) {
  return _Helpers.pMedia.xl(_templateObject8(), props.containerWidth * 0.35 + "px;", (0, _CanvasContainer.maxAssetSize)(props.containerWidth).height + "px;");
}, _Helpers.pMedia.md(_templateObject9()));

var Disclaimer = _styledComponents.default.div.withConfig({
  displayName: "CanvasSlideshow__Disclaimer",
  componentId: "sc-1q5kr05-0"
})(["margin:-5px 0 0;", ";"], _Helpers.pMedia.md(_templateObject10()));

var Image = responsiveImage(_templateObject11(), function (props) {
  return (0, _CanvasContainer.maxAssetSize)(props.containerWidth).width + "px;";
}, function (props) {
  return _Helpers.pMedia.lg(_templateObject12(), (0, _CanvasContainer.maxAssetSize)(props.containerWidth).height + "px;");
});

var Caption = _styledComponents.default.div.withConfig({
  displayName: "CanvasSlideshow__Caption",
  componentId: "sc-1q5kr05-1"
})(["", ";color:", ";margin-top:10px;"], (0, _Fonts.garamond)("s11"), _Colors.default.grayMedium);
//# sourceMappingURL=CanvasSlideshow.js.map